
import { MaterialTransferido } from "@/shared/interfaces";
import { PaginationState } from "@tanstack/table-core";
import { create } from "zustand";

interface CuadreState {
  paginatedData: MaterialTransferido[];

  productos: MaterialTransferido[];
  pagination: PaginationState;
  setPagination: (pagination: PaginationState | ((prev: PaginationState) => PaginationState)) => void;
  handleActualizarProducto: (id: string, nuevosValores: Partial<MaterialTransferido>) => void;
  handleCopiarLista: (producto: MaterialTransferido[]) => void
  clearSelectedItems: () => void;

}

export const useCuadreMaterial = create<CuadreState>((set) => ({
  paginatedData: [],
  productos: [],
  pagination: { pageIndex: 0, pageSize: 5 },
  setPagination: (pagination) => {
    set((state) => {
      const newPagination = typeof pagination === "function"
        ? pagination(state.pagination)
        : pagination;
      return {
        pagination: newPagination,
        paginatedData: state.productos.slice(
          newPagination.pageIndex * newPagination.pageSize,
          (newPagination.pageIndex + 1) * newPagination.pageSize
        ),
      };
    });
  },

  handleActualizarProducto: (id, nuevosValores) => {

    set((state) => {
      const productosActualizados = state.productos.map((producto) =>
        producto.id === id ? { ...producto, ...nuevosValores } : producto
      );
      return {
        productos: productosActualizados,
        paginatedData: productosActualizados.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        ),

      };
    });
  },
  handleCopiarLista(producto) {

    set((state) => {
      return {
        productos: producto,
        paginatedData: producto.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        ),
      };
    });
  },
  clearSelectedItems() {
    set(() => {
      return {
        pagination: { pageIndex: 0, pageSize: 5 },
        paginatedData: [],
        productos: [],
        auxRow: null
      };
    });
  },


}))